(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["emergency-kits-collection"]) return;
  try {
    
if (!customElements.get('emergency-kits-collection')) {
  customElements.define('emergency-kits-collection', class extends HTMLElement {
    connectedCallback() {
      if (this.events) return;
      this.events = new AbortController();
      this.pendingCarts = new Set();
      this.requestNumber = 0;
      const on = (el, type, fn, options = {}) => el?.addEventListener(type, fn, { ...options, signal: this.events.signal });
      this.querySelector('#burger')?.setAttribute('aria-expanded', 'false');
      const menu = open => {
        const button = this.querySelector('#burger');
        button?.setAttribute('aria-expanded', String(open));
        button?.setAttribute('aria-label', open ? 'Close menu' : 'Open menu');
        this.querySelector('#mobileNav')?.classList.toggle('is-open', open);
      };
      on(this, 'click', e => {
        const button = e.target.closest('button');
        const link = e.target.closest('a');
        if (button?.id === 'burger') menu(button.getAttribute('aria-expanded') !== 'true');
        if (button?.matches('.header__search-btn')) {
          const search = this.querySelector('.header__search');
          search?.classList.toggle('ek-search-open');
          if (search?.classList.contains('ek-search-open')) search.querySelector('input')?.focus();
        }
        if (button?.id === 'simTabsNext') this.querySelector('#simTabs')?.scrollBy({ left: this.querySelector('#simTabs').clientWidth * .7, behavior: 'smooth' });
        if (button?.id === 'simFToggle') this.setFilters(button.getAttribute('aria-expanded') !== 'true');
        if (button?.id === 'simFDone') { this.setFilters(false, true); this.flushFilters(); }
        if (button?.matches('[data-people-values]')) {
          const values = JSON.parse(button.dataset.peopleValues);
          const inputs = [...this.querySelectorAll('[data-people-filter] input')].filter(input => values.includes(input.value));
          const checked = button.getAttribute('aria-pressed') !== 'true';
          inputs.forEach(input => { if (!input.disabled || input.checked) input.checked = checked; });
          this.syncPeople(); this.scheduleFilters(0);
        }
        if (button?.id === 'aboutMore') {
          const open = this.querySelector('#aboutText')?.classList.toggle('is-open');
          button.setAttribute('aria-expanded', String(open)); button.textContent = open ? 'Show less' : 'Show more';
        }
        if (button?.matches('[data-retry]') && this.lastRequest) this.updateResults(...this.lastRequest);
        if (link && !e.metaKey && !e.ctrlKey && !e.shiftKey && !e.altKey && e.button === 0) {
          if (link.matches('[data-filter-link],[data-page-link],[data-load-more]')) {
            e.preventDefault(); clearTimeout(this.filterTimer);
            const url = new URL(link.href);
            // Keep the template preview and local embedding while using Shopify-generated links.
            for (const key of ['view', 'preview_theme_id', 'embed', '_fd', '_ab', '_sc']) if (new URL(location.href).searchParams.has(key)) url.searchParams.set(key, new URL(location.href).searchParams.get(key));
            this.updateResults(url.href, link.hasAttribute('data-load-more') ? 'append' : 'replace', true);
          }
        }
      });
      on(this, 'submit', e => {
        if (e.target.matches('[data-filter-form]')) { e.preventDefault(); this.flushFilters(); }
        if (e.target.matches('[data-product-form]')) { e.preventDefault(); this.addToCart(e.target); }
      });
      on(this, 'change', e => {
        if (e.target.matches('[data-sort], [data-filter-form] input')) {
          if (e.target.matches('[data-price-max]')) {
            const slider = this.querySelector('[data-price-slider]'); if (slider) slider.value = e.target.value || slider.max;
          }
          this.scheduleFilters(e.target.type === 'number' ? 350 : 0);
        }
      });
      on(this, 'input', e => {
        if (e.target.matches('[data-price-slider]')) { this.querySelector('[data-price-max]').value = e.target.value; this.scheduleFilters(300); }
        if (e.target.matches('[data-price-min], [data-price-max]')) this.scheduleFilters(550);
      });
      on(this, 'keydown', e => {
        if (e.key === 'Escape') {
          if (this.querySelector('#simFilters.is-open')) this.setFilters(false, true);
          if (this.querySelector('#mobileNav.is-open')) { menu(false); this.querySelector('#burger')?.focus(); }
          this.querySelector('.header__search')?.classList.remove('ek-search-open');
        }
      });
      on(window, 'popstate', () => { clearTimeout(this.filterTimer); this.updateResults(location.href, 'replace', false); });
      on(window, 'resize', () => { this.syncTabs(); if (innerWidth >= 900) this.setFilters(false); }, { passive: true });
      // Capturing scroll handles horizontal tabs after a section replacement.
      on(this, 'scroll', e => { if (e.target.id === 'simTabs') this.syncTabs(); }, { capture: true, passive: true });
      this.enhanceRegion();
    }
    disconnectedCallback() {
      this.events?.abort(); this.events = null; this.request?.abort();
      clearTimeout(this.filterTimer); this.pendingCarts?.forEach(controller => controller.abort());
      this.cartTimers?.forEach(timer => clearTimeout(timer));
    }
    enhanceRegion() {
      const region = this.querySelector('[data-collection-region]');
      region?.classList.add('is-enhanced');
      const fieldset = region?.querySelector('[data-people-filter]');
      if (fieldset) {
        const inputs = [...fieldset.querySelectorAll('input[type=checkbox]')];
        const parsed = inputs.map(input => ({ input, n: /^\d+\s*(?:Person|People)?$/i.test(input.value) ? parseInt(input.value, 10) : NaN }));
        if (parsed.length && parsed.every(x => Number.isFinite(x.n))) {
          const container = document.createElement('div'); container.className = 'people-groups';
          const groups = [[1,1,'1'],[2,2,'2'],[3,3,'3'],[4,4,'4'],[5,10,'5–10'],[20,50,'20–50'],[60,100,'60–100'],[250,Infinity,'250+']];
          const covered = new Set();
          for (const [min,max,label] of groups) {
            const members = parsed.filter(x => x.n >= min && x.n <= max); if (!members.length) continue;
            members.forEach(x => covered.add(x.input));
            const button = document.createElement('button'); button.type = 'button'; button.className = 'people-group'; button.textContent = label; button.dataset.peopleValues = JSON.stringify(members.map(x => x.input.value));
            button.setAttribute('aria-label', `${label} people`); container.append(button);
          }
          for (const {input} of parsed.filter(x => !covered.has(x.input))) {
            const button = document.createElement('button'); button.type = 'button'; button.className = 'people-group'; button.textContent = input.value; button.dataset.peopleValues = JSON.stringify([input.value]); container.append(button);
          }
          fieldset.querySelector('.people-groups')?.remove(); fieldset.append(container); this.syncPeople();
        } else fieldset.querySelector('.native-people')?.classList.remove('native-people');
      }
      const badge = region?.querySelector('.sim__fcount');
      if (badge) {
        const checked = [...region.querySelectorAll('[data-filter-form] input[type=checkbox]:checked')].filter(input => !input.closest('[data-people-filter]')).length;
        const groups = region.querySelectorAll('[data-people-values][aria-pressed=true]').length;
        const plainPeople = region.querySelector('.people-groups') ? 0 : region.querySelectorAll('[data-people-filter] input:checked').length;
        const price = [...region.querySelectorAll('[data-price-min],[data-price-max]')].some(input => input.value !== '');
        const count = checked + groups + plainPeople + Number(price); badge.textContent = count; badge.hidden = count === 0;
      }
      this.syncTabs();
    }
    syncPeople() {
      for (const button of this.querySelectorAll('[data-people-values]')) {
        const values = JSON.parse(button.dataset.peopleValues);
        const inputs = [...this.querySelectorAll('[data-people-filter] input')].filter(input => values.includes(input.value));
        const n = inputs.filter(input => input.checked).length;
        button.setAttribute('aria-pressed', String(n > 0)); button.classList.toggle('is-partial', n > 0 && n < inputs.length);
        button.disabled = inputs.every(input => input.disabled && !input.checked);
      }
    }
    syncTabs() {
      const tabs = this.querySelector('#simTabs'), next = this.querySelector('#simTabsNext');
      if (tabs && next) next.hidden = tabs.scrollWidth - tabs.clientWidth - tabs.scrollLeft < 8;
    }
    setFilters(open, focus = false) {
      const panel = this.querySelector('#simFilters'), toggle = this.querySelector('#simFToggle');
      panel?.classList.toggle('is-open', open); toggle?.setAttribute('aria-expanded', String(open));
      if (open) panel?.querySelector('input:not([disabled]),button')?.focus({ preventScroll: true });
      else if (focus) toggle?.focus({ preventScroll: true });
    }
    scheduleFilters(delay) { clearTimeout(this.filterTimer); this.request?.abort(); this.filterTimer = setTimeout(() => this.flushFilters(), delay); }
    flushFilters() {
      clearTimeout(this.filterTimer);
      const form = this.querySelector('[data-filter-form]'); if (!form) return;
      const min = form.querySelector('[data-price-min]'), max = form.querySelector('[data-price-max]');
      max?.setCustomValidity('');
      if (min?.value && max?.value && Number(min.value) > Number(max.value)) max.setCustomValidity('Maximum price must be at least the minimum price.');
      if (!form.reportValidity()) return;
      const url = new URL(form.action, location.href), current = new URL(location.href);
      for (const key of ['view','preview_theme_id','embed','_fd','_ab','_sc']) if (current.searchParams.has(key)) url.searchParams.set(key,current.searchParams.get(key));
      for (const [key,value] of new FormData(form)) if (String(value).trim() !== '') url.searchParams.append(key,value);
      // An external sort control belongs to this native GET form.
      if (!url.searchParams.has('sort_by')) { const sort = this.querySelector('[data-sort]'); if (sort) url.searchParams.set('sort_by',sort.value); }
      this.updateResults(url.href,'replace',true);
    }
    async updateResults(href, mode = 'replace', push = true) {
      this.request?.abort(); const controller = new AbortController(); this.request = controller;
      const n = ++this.requestNumber; this.lastRequest = [href,mode,push];
      let region = this.querySelector('[data-collection-region]'); if (!region) return;
      const wasOpen = Boolean(region.querySelector('#simFilters.is-open'));
      const active = document.activeElement;
      const focus = region.contains(active) ? { id:active.id, name:active.name, value:active.value, group:active.dataset?.peopleValues } : null;
      const scroll = region.querySelector('#simTabs')?.scrollLeft || 0;
      region.classList.add('is-loading'); region.setAttribute('aria-busy','true');
      region.querySelector('.collection-error').hidden = true;
      try {
        const url = new URL(href,location.href); url.searchParams.set('section_id',this.dataset.sectionId);
        const response = await fetch(url.href,{signal:controller.signal,headers:{'X-Requested-With':'XMLHttpRequest'}});
        if (!response.ok) throw new Error('Unable to load products');
        const document = new DOMParser().parseFromString(await response.text(),'text/html');
        const next = document.querySelector('[data-collection-region]');
        if (!next || n !== this.requestNumber || controller.signal.aborted) { if (!next) throw new Error('Missing product results'); return; }
        if (mode === 'append') {
          const grid = region.querySelector('#simGrid'); const nextCards = [...next.querySelectorAll('#simGrid .pcard')];
          const ids = new Set([...grid.querySelectorAll('[data-product-id]')].map(card=>card.dataset.productId));
          const first = nextCards.find(card => !ids.has(card.dataset.productId));
          for (const card of nextCards) if (!ids.has(card.dataset.productId)) grid.append(card);
          region.querySelector('[data-pagination]').replaceWith(next.querySelector('[data-pagination]'));
          region.querySelector('[data-showing]').textContent = grid.querySelectorAll('.pcard').length;
          first?.querySelector('h3 a')?.focus({preventScroll:true});
          // Keep the first page URL when appending so a refresh/popstate cannot lose earlier products.
        } else {
          region.replaceWith(next); region = next; this.enhanceRegion(); this.setFilters(wasOpen);
          const tabs = region.querySelector('#simTabs'); if (tabs) tabs.scrollLeft = scroll;
          if (push && href !== location.href) history.pushState({},'',href);
          if (focus) {
            let target;
            if (focus.group) target = [...region.querySelectorAll('[data-people-values]')].find(el=>el.dataset.peopleValues === focus.group);
            else if (focus.id) target = [...region.querySelectorAll('[id]')].find(el=>el.id === focus.id);
            else if (focus.name) target = [...region.querySelectorAll('[name]')].find(el=>el.name === focus.name && (el.type!=='checkbox'||el.value===focus.value));
            target?.focus({preventScroll:true});
          }
        }
        this.lastRequest = null; this.syncTabs();
      } catch (error) {
        if (error.name !== 'AbortError' && n === this.requestNumber) region.querySelector('.collection-error').hidden = false;
      } finally {
        if (n === this.requestNumber) { region.classList.remove('is-loading'); region.removeAttribute('aria-busy'); }
      }
    }
    async addToCart(form) {
      const button = form.querySelector('button[type=submit]'); if (!button || button.disabled) return;
      const label = button.textContent; const error = form.querySelector('[role=alert]');
      const controller = new AbortController(); this.pendingCarts.add(controller);
      button.disabled = true; button.textContent = this.dataset.adding; error.hidden = true;
      try {
        const response = await fetch(this.dataset.cartAdd,{method:'POST',headers:{Accept:'application/json'},body:new FormData(form),signal:controller.signal});
        const result = await response.json(); if (!response.ok) throw new Error(result.description || result.message || this.dataset.error);
        button.textContent = this.dataset.added;
        // Retrieve the authoritative cart count, including quantities already in the cart.
        try {
          const cartResponse = await fetch(this.dataset.cartJson,{headers:{Accept:'application/json'},signal:controller.signal});
          if (cartResponse.ok) { const cart = await cartResponse.json(); const badge=this.querySelector('#cartN'); if (badge) { badge.textContent=cart.item_count; badge.closest('a')?.setAttribute('aria-label',`Cart, ${cart.item_count} items`); } }
        } catch (countError) { if (countError.name==='AbortError') throw countError; }
        this.dispatchEvent(new CustomEvent('cart:refresh',{bubbles:true,detail:{product:result}}));
        this.cartTimers ||= new Set();
        const timer=setTimeout(()=>{button.textContent=label;button.disabled=false;this.cartTimers.delete(timer);},1600);this.cartTimers.add(timer);
      } catch (err) {
        button.textContent=label;button.disabled=false;
        if (err.name!=='AbortError') { error.textContent=err.message || this.dataset.error;error.hidden=false; }
      } finally { this.pendingCarts.delete(controller); }
    }
  });
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["floating-add-to-cart"] && !Shopify.designMode) return;
  try {
    
(function () {
  const section = document.querySelector('.floating-cart-section');
  if (!section) return;

  const switchEl = section.querySelector('#cart-button-switch');
  if (!switchEl) return;

  const mq = window.matchMedia('(max-width: 768px)');
  const HYSTERESIS = 48;
  let fixmeTop = 0;
  let isActive = false;
  let ticking = false;

  function measureThreshold() {
    fixmeTop = switchEl.getBoundingClientRect().top + window.scrollY;
  }

  function setActive(next) {
    if (isActive === next) return;
    isActive = next;
    section.classList.toggle('has-sticky-atc', next);
  }

  function updateStickyAtcState() {
    if (!mq.matches) {
      setActive(false);
      return;
    }

    const scrollY = window.scrollY;

    if (!isActive && scrollY >= fixmeTop) {
      setActive(true);
    } else if (isActive && scrollY < fixmeTop - HYSTERESIS) {
      setActive(false);
    }
  }

  function onScroll() {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(function () {
      updateStickyAtcState();
      ticking = false;
    });
  }

  measureThreshold();
  updateStickyAtcState();

  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', function () {
    measureThreshold();
    updateStickyAtcState();
  });
  mq.addEventListener('change', function () {
    measureThreshold();
    updateStickyAtcState();
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["points-earned"] && !Shopify.designMode) return;
  try {
    
  // No JavaScript needed for this example

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-kit-family-picker"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initKitFamilyPicker = () => {
      document.querySelectorAll('[data-kit-family-picker]').forEach((section) => {
        const toggle = section.querySelector('[data-kit-family-toggle]');
        const toggleText = section.querySelector('[data-kit-family-toggle-text]');
        const details = section.querySelector('[data-kit-family-details]');
        const panel = section.querySelector('[data-kit-family-panel]');
        const closeBtn = section.querySelector('[data-kit-family-close]');
        if (!toggle || !toggleText || !details || toggle.dataset.ready === 'true') return;

        const collapsedText = toggleText.textContent;
        const expandedText = 'Hide Details';
        const mobileQuery = window.matchMedia('(max-width: 589px)');

        const setCompareOpen = (isOpen) => {
          toggle.setAttribute('aria-expanded', String(isOpen));
          details.hidden = !isOpen;
          section.classList.toggle('pkfp-compare-open', isOpen);
          document.documentElement.classList.toggle('pkfp-modal-lock', isOpen && mobileQuery.matches);
          toggleText.textContent = isOpen ? expandedText : collapsedText;
        };

        toggle.addEventListener('click', () => {
          const willExpand = toggle.getAttribute('aria-expanded') !== 'true';
          setCompareOpen(willExpand);
        });

        if (closeBtn) {
          closeBtn.addEventListener('click', (event) => {
            event.preventDefault();
            event.stopPropagation();
            setCompareOpen(false);
          });
        }

        details.addEventListener('click', (event) => {
          if (mobileQuery.matches && event.target === details) {
            setCompareOpen(false);
          }
        });

        if (panel) {
          panel.addEventListener('click', (event) => {
            if (event.target.closest('[data-kit-family-close]')) return;
            event.stopPropagation();
          });
        }

        document.addEventListener('keydown', (event) => {
          if (event.key === 'Escape' && toggle.getAttribute('aria-expanded') === 'true') {
            setCompareOpen(false);
          }
        });

        mobileQuery.addEventListener('change', () => {
          document.documentElement.classList.toggle(
            'pkfp-modal-lock',
            toggle.getAttribute('aria-expanded') === 'true' && mobileQuery.matches
          );
        });

        toggle.dataset.ready = 'true';
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initKitFamilyPicker);
    } else {
      initKitFamilyPicker();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-meta-description"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initProductMetaDescriptions = () => {
      document.querySelectorAll('[data-product-meta-description]').forEach((section) => {
        const source = section.querySelector('.pmd-source');
        const target = section.querySelector('[data-pmd-generated]');

        if (!source || !target || target.dataset.ready === 'true') return;

        const highlightQty = (html) => (html || '').replace(/(\[X\d+\])/g, '<span class="pmd-qty">$1</span>');

        const getExplicitItemImage = (item) => {
          const itemImage = item.getAttribute('data-pmd-image');
          if (itemImage) return itemImage;

          const imageNode = item.querySelector('[data-pmd-image], img[data-pmd-hero]');
          if (!imageNode) return '';

          return imageNode.getAttribute('data-pmd-image')
            || imageNode.getAttribute('src')
            || imageNode.getAttribute('data-src')
            || '';
        };

        const sourceSections = Array.from(source.querySelectorAll('.video-text--section'));
        const groups = sourceSections.map((sourceSection) => {
          const titleNode = sourceSection.querySelector('.icon_text--title');
          const title = titleNode ? titleNode.textContent.trim() : '';
          const heroImage = sourceSection.querySelector('.video-element--poster img, .video-text__video video');
          const heroSrc = heroImage ? heroImage.getAttribute('src') || heroImage.getAttribute('poster') : '';
          const items = Array.from(sourceSection.querySelectorAll('.icon_text--inner')).map((item) => {
            const itemTitle = item.querySelector('.icon_text--content h4');
            const details = item.querySelector('.icon_text--content');
            const thumb = item.querySelector('.icon_text--icon img');

            const detailsHtml = details
              ? Array.from(details.children)
                .filter((node) => node.tagName !== 'H4')
                .map((node) => node.outerHTML)
                .join('')
              : '';

            return {
              titleHtml: itemTitle ? highlightQty(itemTitle.innerHTML) : '',
              detailsHtml: highlightQty(detailsHtml),
              thumbSrc: thumb ? thumb.getAttribute('src') : '',
              heroSrc: getExplicitItemImage(item) || heroSrc
            };
          }).filter((item) => item.titleHtml && item.detailsHtml);

          return { title, items };
        }).filter((group) => group.title && group.items.length);

        if (!groups.length) {
          source.hidden = false;
          target.remove();
          return;
        }

        const heading = document.createElement('h2');
        heading.className = 'pmd-title';
        heading.textContent = "What’s Included?";

        const header = document.createElement('div');
        header.className = 'pmd-header';

        const tabs = document.createElement('div');
        tabs.className = 'pmd-tabs';
        tabs.setAttribute('role', 'tablist');
        tabs.setAttribute('aria-label', "What’s included categories");

        const grid = document.createElement('div');
        grid.className = 'pmd-grid';

        const carousel = document.createElement('div');
        carousel.className = 'pmd-carousel';

        const prevButton = document.createElement('button');
        prevButton.type = 'button';
        prevButton.className = 'pmd-carousel-nav pmd-carousel-nav--prev';
        prevButton.setAttribute('aria-label', 'Previous product');
        prevButton.innerHTML = '<svg aria-hidden="true" focusable="false" viewBox="0 0 10 29"><path d="M8 26 2 14.5 8 3" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/></svg>';

        const nextButton = document.createElement('button');
        nextButton.type = 'button';
        nextButton.className = 'pmd-carousel-nav pmd-carousel-nav--next';
        nextButton.setAttribute('aria-label', 'Next product');
        nextButton.innerHTML = '<svg aria-hidden="true" focusable="false" viewBox="0 0 10 29"><path d="M2 3l6 11.5L2 26" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/></svg>';

        const dots = document.createElement('div');
        dots.className = 'pmd-carousel-dots';
        dots.setAttribute('aria-hidden', 'true');

        const mobileQuery = window.matchMedia('(max-width: 589px)');

        const getActiveIndex = () => {
          const slideWidth = grid.clientWidth;
          return slideWidth > 0 ? Math.round(grid.scrollLeft / slideWidth) : 0;
        };

        const updateDots = () => {
          if (!mobileQuery.matches) return;

          const dotItems = Array.from(dots.children);
          const activeIndex = Math.min(Math.max(getActiveIndex(), 0), dotItems.length - 1);
          dotItems.forEach((dot, index) => {
            dot.classList.toggle('is-active', index === activeIndex);
          });
        };

        const goToSlide = (index) => {
          if (!mobileQuery.matches) return;

          const dotItems = Array.from(dots.children);
          const cappedIndex = Math.min(Math.max(index, 0), dotItems.length - 1);
          grid.scrollTo({
            left: cappedIndex * grid.clientWidth,
            behavior: 'smooth'
          });
        };

        const getGroupKey = (title) => title.trim().toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');

        const renderCards = (groupIndex) => {
          const activeGroup = groups[groupIndex];
          const activeGroupKey = getGroupKey(activeGroup.title);
          const itemCount = activeGroup.items.length;
          let layout = 'grid';

          if (itemCount === 1) {
            layout = 'single';
          } else if (itemCount === 3) {
            layout = 'triple';
          }

          carousel.dataset.activeGroup = activeGroupKey;
          carousel.dataset.layout = layout;
          carousel.dataset.itemCount = String(itemCount);
          grid.innerHTML = '';
          dots.innerHTML = '';

          activeGroup.items.forEach((item, itemIndex) => {
            const card = document.createElement('article');
            card.className = 'pmd-card';

            const media = document.createElement('div');
            media.className = 'pmd-card-media';

            if (item.heroSrc) {
              const hero = document.createElement('img');
              hero.src = item.heroSrc;
              hero.alt = '';
              hero.loading = 'lazy';
              media.appendChild(hero);
            }

            let thumbWrap = null;
            if (item.thumbSrc) {
              thumbWrap = document.createElement('div');
              thumbWrap.className = 'pmd-card-thumb';
              const thumb = document.createElement('img');
              thumb.src = item.thumbSrc;
              thumb.alt = '';
              thumb.loading = 'lazy';
              thumbWrap.appendChild(thumb);

              if (layout === 'single') {
                thumbWrap.classList.add('pmd-card-thumb--inline');
              } else {
                media.appendChild(thumbWrap);
              }
            }

            const body = document.createElement('div');
            body.className = 'pmd-card-body';
            body.innerHTML = `<h3 class="pmd-card-title">${item.titleHtml}</h3>${item.detailsHtml}`;

            if (layout === 'single' && thumbWrap) {
              body.prepend(thumbWrap);
            }

            card.append(media, body);
            grid.appendChild(card);

            const dot = document.createElement('button');
            dot.type = 'button';
            dot.className = 'pmd-carousel-dot';
            if (itemIndex === 0) dot.classList.add('is-active');
            dot.addEventListener('click', () => {
              goToSlide(itemIndex);
            });
            dots.appendChild(dot);
          });

          grid.scrollTo({ left: 0, behavior: 'auto' });
          updateDots();
        };

        groups.forEach((group, index) => {
          const button = document.createElement('button');
          button.type = 'button';
          button.className = 'pmd-tab';
          button.textContent = group.title;
          button.setAttribute('role', 'tab');
          button.setAttribute('aria-selected', 'false');
          button.addEventListener('click', () => {
            tabs.querySelectorAll('.pmd-tab').forEach((tab) => {
              tab.classList.remove('is-active');
              tab.setAttribute('aria-selected', 'false');
            });
            button.classList.add('is-active');
            button.setAttribute('aria-selected', 'true');
            renderCards(index);
          });
          tabs.appendChild(button);
        });

        carousel.append(grid, prevButton, nextButton, dots);
        header.append(heading, tabs);
        target.append(header, carousel);
        target.dataset.ready = 'true';

        prevButton.addEventListener('click', () => {
          goToSlide(getActiveIndex() - 1);
        });

        nextButton.addEventListener('click', () => {
          goToSlide(getActiveIndex() + 1);
        });

        let ticking = false;
        grid.addEventListener('scroll', () => {
          if (!mobileQuery.matches || ticking) return;

          ticking = true;
          window.requestAnimationFrame(() => {
            updateDots();
            ticking = false;
          });
        }, { passive: true });

        mobileQuery.addEventListener('change', () => {
          if (!mobileQuery.matches) {
            grid.scrollTo({ left: 0, behavior: 'auto' });
            return;
          }

          updateDots();
        });

        const defaultIndex = Math.max(0, groups.findIndex((group) => group.title.toLowerCase() === 'shelter'));
        const defaultTab = tabs.children[defaultIndex];
        if (defaultTab) defaultTab.click();
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initProductMetaDescriptions);
    } else {
      initProductMetaDescriptions();
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
